module.exports = __webpack_public_path__ + "media/images/ac_templates/201/vtmrn-855bbeb07710803f00db8306ea8a36a7.jpg";